import React from "react";
import { Button, Drawer, Form, Input, Select, Spin } from "antd";
import debounce from "lodash/debounce";
import { TruckOwnershipList, TruckOwnershipPost } from "../models/truck_ownership";

const FormItem = Form.Item;
const Option = Select.Option;

class TruckOwnershipFilterForm extends React.Component {
  state = {
    visible: false,
    data: [],
    value: [],
    fetching: false,
  };
  showDrawer = () => {
    this.setState({
      visible: true
    });
  };
  onClose = () => {
    this.setState({
      visible: false
    });
  };
  fetchTruckOwnership = (value = '') => {
    this.setState({ data: [], fetching: true });
    const requestData = { 'search': value };
    TruckOwnershipList(requestData)
      .then(body => {
        const data = body.data.results.map(ownership => ({
          text: `${ownership.name}`,
          value: ownership.id
        }));
        this.setState({ data, fetching: false });
      });
  };

  handleChange = (value) => {
    this.setState({
      value,
      fetching: false
    });
    this.props.onChange(value.key);
  };
  handleDrawerSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        TruckOwnershipPost(values)
          .then(response => {
            if (response) {
              this.setState({
                visible: false,
                value: { key: response.id, label: response.name }
              });
              this.props.onChange(response.id);
            }
          });
      }
    });
  };

  constructor(props) {
    super(props);
    this.fetchTruckOwnership = debounce(this.fetchTruckOwnership, 800);
  }

  componentDidMount() {
    if (this.props.onRef)
      this.props.onRef(this)

  }

  componentWillUnmount() {
    if (this.props.onRef)
      this.props.onRef(null)
  }

  render() {
    const { fetching, data, value } = this.state;
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="pos-relative">
        <Select labelInValue showSearch value={value} dropdownClassName="drawer-select" placeholder="Select Truck Ownership" notFoundContent={fetching ? <Spin size="small" /> : "Not Found"} filterOption={false} onFocus={this.fetchTruckOwnership} onSearch={this.fetchTruckOwnership} onChange={this.handleChange} style={{ width: "100%" }}>
          {data.map(d => (<Option key={d.value}>{d.text}</Option>))}
        </Select>
        <Button className="plus-btn-pop " type="primary" htmlType="button" onClick={this.showDrawer}>
          <i className="fa fa-plus" />
        </Button>
        <div>
          <Drawer title="Add Ownership" placement="right" onClose={this.onClose} visible={this.state.visible}
            className="floating-form" destroyOnClose={true}>
            <Form>
              <FormItem label="Ownership Name">
                {getFieldDecorator('name', {
                  rules: [{ required: true, message: 'Please input ownership' }],
                })(<Input placeholder="Enter Ownership" />)}
              </FormItem>
              <Button type="primary" htmlType="button" onClick={this.handleDrawerSubmit} className="login-form-button">Add
                Ownership</Button>
            </Form>
          </Drawer>
        </div>
      </div>
    );
  }
}

export const TruckOwnershipFilter = Form.create()(TruckOwnershipFilterForm);



// WEBPACK FOOTER //
// ./src/filters/TruckOwnership.jsx